import { VotacionRemotaComponent } from './cliente/votacion-remota/votacion-remota.component';
import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AppRoutingModule} from './app-routing.module';
import {MaterialModule} from './material.module';
import {BootstrapModule} from './bootstrap.module';
import {MatCardModule} from '@angular/material/card';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ValidacionAsistenteComponent} from './cliente/validacion-asistente/validacion-asistente.component';
import {VotacionComponent} from './cliente/votacion/votacion.component';
import {FinVotacionComponent} from './cliente/fin-votacion/fin-votacion.component';
import {LoginComponent} from './intranet/login/login.component';
import {AdminComponent} from './intranet/admin/admin.component';
import {ResultadoComponent} from './intranet/admin/resultado/resultado.component';
import {DialogAumentarTiempoComponent} from './intranet/admin/resultado/dialog-aumentar-tiempo/dialog-aumentar-tiempo.component';
import {AsistenciaComponent} from './intranet/admin/asistencia/asistencia.component';
import {BienvenidaAsistenteComponent} from './cliente/bienvenida-asistente/bienvenida-asistente.component';
import {ConfirmDialogComponent} from './util/confirm-dialog/confirm-dialog.component';
import {RegistroAsistenteDialogComponent} from './intranet/admin/asistencia/registro-asistente/registro-asistente-dialog.component';
import {AccesoComponent} from './intranet/admin/acceso/acceso.component';
import {AsambleaComponent} from './intranet/admin/asamblea/asamblea.component';
import {RepresentanteComponent} from './intranet/admin/representante/representante.component';
import {RegistroOpcionDialogComponent} from './intranet/admin/asamblea/registro-opcion/registro-opcion-dialog.component';
import {
  RegistroRepresentanteComponent
} from './intranet/admin/representante/registro-representante/registro-representante-dialog.component';
import { AsambleaBandejaComponent } from './intranet/admin/asamblea-bandeja/asamblea-bandeja.component';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {JwtInterceptorService} from './intranet/helper/jwtinterceptor.service';
import {ResponseInterceptorService} from './intranet/helper/responseinterceptor.service';
import {MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import {SURA_FORMATS} from './util/functionConst';
import {MomentDateAdapter} from '@angular/material-moment-adapter';
import {CambiarContraseniaComponent} from './intranet/login/cambiar-contrasenia/cambiar-contrasenia.component';
import {EnviarEstadisticaComponent} from './intranet/admin/resultado/enviar-estadistica/enviar-estadistica.component';
import {PiePaginaComponent} from './pie-pagina/pie-pagina.component';
import { AppConfigProvider } from 'src/app/app-config.provider';
import { AppConfigService } from 'src/app/app-config.service';
import {
  RECAPTCHA_SETTINGS,
  RECAPTCHA_LANGUAGE,
  RecaptchaModule,
  RecaptchaSettings,
} from 'ng-recaptcha';
import { EstadoDialogComponent } from './intranet/admin/asamblea-bandeja/estado-dialog/estado-dialog.component';
import { ImportacionFondoComponent } from './intranet/admin/importacion-fondo/importacion-fondo.component';
import { LoaderComponent } from './loader/components/loader.component';
import { LoaderService } from './loader/services/loader.service';
import { LoaderInterceptor } from './loader/services/loader-interceptor.service';
import { VotacionEdicionComponent } from './cliente/votacion-edicion/votacion-edicion.component';

const globalSettings: RecaptchaSettings = { siteKey: '6LeTf68UAAAAAKEsJuKUhGHbuL343q9zkajYZ5AS' };

@NgModule({
    declarations: [
        AppComponent,
        ValidacionAsistenteComponent,
        VotacionComponent,
        VotacionRemotaComponent,
        VotacionEdicionComponent,
        FinVotacionComponent,
        LoginComponent,
        AdminComponent,
        ResultadoComponent,
        DialogAumentarTiempoComponent,
        AsistenciaComponent,
        ConfirmDialogComponent,
        RegistroAsistenteDialogComponent,
        AccesoComponent,
        AsambleaComponent,
        RepresentanteComponent,
        RegistroOpcionDialogComponent,
        RegistroRepresentanteComponent,
        CambiarContraseniaComponent,
        EnviarEstadisticaComponent,
        PiePaginaComponent,
        AsambleaBandejaComponent,
        BienvenidaAsistenteComponent,
        EstadoDialogComponent,
        ImportacionFondoComponent,
        LoaderComponent
    ],
    imports: [
        HttpClientModule,
        BrowserModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        MaterialModule,
        BootstrapModule,
        FormsModule,
        AppRoutingModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        RecaptchaModule,
        MatCardModule,
        MatProgressBarModule,
        MatDialogModule
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptorService, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ResponseInterceptorService, multi: true },
        { provide: MAT_DATE_LOCALE, useValue: 'es' },
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: SURA_FORMATS },
        {
            provide: RECAPTCHA_SETTINGS,
            useValue: globalSettings
        },
        {
            provide: RECAPTCHA_LANGUAGE,
            useValue: 'es', // español por defecto
        },
        AppConfigProvider,
        AppConfigService,
        LoaderService,
        { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true }
    ],
    bootstrap: [AppComponent]
})

export class AppModule {
}
